// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"1f99de06","126":"23abec56","443":"08208701","614":"620cf73d","935":"c4ba0c15"}[chunkId] + ".css";
};